//Z3950Document2
import { Name2 } from '../../ui/ot';


const Z3950Document2 = ({
}) => {
    return <>
        <Name2
            propsCategoryName="客戶資料"
            propsCategoryTitle="資料欄位"

            propsPrimaryColorName='blue'
            propsPrimaryColor="#1e40af"
            propsSecodaryColor="#2563eb"
            propsBackgroundColor="linear-gradient(to right, #eff6ff, #eef2ff)"

            selectionApiRoute='/cataloging/backend/z3950_selection'
            templateApiRoute='/cataloging/backend/z3950_document/view'
            mainApiRoute='/cataloging/backend/z3950_document/view'
            folderApiRoute="/cataloging/backend/z3950_folder"

            pageFrontendRoute='/cataloging/z3950_document/_3'//前端路徑，新增完成後重整用
            dbCoverIdName='z3950_document_id'
        />
    </>
}

export default Z3950Document2
